import React, { useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Select from "components/ui/Select";
import useAuth from "hooks/useAuth";

const OpeningTrail = () => {
  const [searchParams] = useSearchParams();
  // const navigate = useNavigate(); // TODO: Uncomment when implementing navigation
  const formTp = searchParams.get("formtp") || "print"; // "print" or "create"
  
  // Get agttp from auth hook
  const { agttp } = useAuth();
  
  // State
  const [openingType, setOpeningType] = useState({ value: "C", label: "Customerwise" });

  // Determine heading suffix based on formtp
  const suffix = formTp === "create" ? "Entry" : "Generator";

  // Opening type options based on agttp
  const openingTypeOptions = useMemo(() => {
    const options = [
      { value: "C", label: "Customerwise" },
      { value: "V", label: "Vendorwise" }
    ];
    
    // Add General Accounts option only for traders (agttp=1)
    if (agttp === 1) {
      options.push({ value: "G", label: "General Accounts" });
    }
    
    return options;
  }, [agttp]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const opntype = openingType?.value;
    
    // TODO: Implement navigation based on formtp and agttp
    // This mimics the PHP logic for different redirects
    
    if (agttp === 0) {
      // Agent logic
      if (formTp === "print") {
        // TODO: Navigate to report page
        console.log("Navigate to: /reports/opening-trail/all?select_opntype=" + opntype);
        // navigate(`/reports/opening-trail/all?select_opntype=${opntype}`);
      } else if (formTp === "create") {
        if (opntype === "V") {
          // TODO: Navigate to credit opening balance
          console.log("Navigate to: /opening-balances/credit");
          // navigate("/opening-balances/credit");
        } else if (opntype === "C") {
          // TODO: Navigate to debit opening balance
          console.log("Navigate to: /opening-balances/debit");
          // navigate("/opening-balances/debit");
        }
      }
    } else if (agttp === 1) {
      // Trader logic
      if (formTp === "print") {
        // TODO: Navigate to report page with genformname
        const genformname = `agtopnbalgen.php?formtp=${formTp}`;
        console.log("Navigate to: /reports/opening-trail/report?genformname=" + genformname + "&select_opntype=" + opntype);
        // navigate(`/reports/opening-trail/report?genformname=${genformname}&select_opntype=${opntype}`);
      } else if (formTp === "create") {
        if (opntype === "G") {
          // TODO: Navigate to general account opening balance
          console.log("Navigate to: /opening-balances/general");
          // navigate("/opening-balances/general");
        } else if (opntype === "V") {
          // TODO: Navigate to credit opening balance
          console.log("Navigate to: /opening-balances/credit");
          // navigate("/opening-balances/credit");
        } else if (opntype === "C") {
          // TODO: Navigate to debit opening balance
          console.log("Navigate to: /opening-balances/debit");
          // navigate("/opening-balances/debit");
        }
      }
    }

    console.log("Opening Trail Form Data:", {
      formTp,
      agttp,
      openingType: opntype
    });
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-2xl font-semibold leading-6 text-gray-900">
            Opening Trail {suffix}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {formTp === "print" 
              ? "Generate opening trail reports" 
              : "Create opening balance entries"}
          </p>
        </div>
      </div>

      <div className="mt-8 bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
        <form onSubmit={handleSubmit}>
          <div className="px-4 py-6 sm:p-8">
            <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
              
              {/* Opening Trial Type */}
              <div className="sm:col-span-3">
                <Select
                  value={openingType}
                  onChange={setOpeningType}
                  options={openingTypeOptions}
                  label="Opening Trial"
                  placeholder="Choose here"
                  isRequired={true}
                  isClearable={false}
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex items-center justify-center gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-8 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OpeningTrail;
